import { useState } from "react";

import logo from '../assets/logo.png'
import '../styles/component-styles.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";

function LoadHeader() {

    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header>
            <a href="/">
                <img src={logo} alt="HWI"/>
                <h1>HyperWorks Imaging</h1>
            </a>

            <div className="desktop-menu">
                <a href="/#about">About</a>
                <a href="/#solutions">Solutions</a>
                <a href="/#research-and-development">R&D</a>
                <a href="/#contact" className="contact-link">Let's talk</a>
            </div>

            <div className="mobile-menu-container">
                <button>
                    <FontAwesomeIcon icon={!menuOpen ? faBars : faClose} onClick={() => setMenuOpen(!menuOpen)}/>
                </button>

                {menuOpen &&
                    <div className="mobile-menu">
                        <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
                        <a href="#solutions" onClick={() => setMenuOpen(false)}>Solutions</a>
                        <a href="#research-and-development" onClick={() => setMenuOpen(false)}>R&D</a>
                        <a href="#contact" className="contact-link" onClick={() =>setMenuOpen(false)}>Let's talk</a>
                    </div>
                }
            </div>
        </header>
    )
}

export default LoadHeader;